import React from 'react';
import PropTypes from 'prop-types';
import { ButtonStyled } from './styled';


export const Button = ({ type = 'default', disabled = false, onClick = null, styles,
                         height = '58px', children, width = '100%', className }) => {
  return (
    <ButtonStyled
      className={`btn btn-${type} ${className}`}
      customStyles={{
        height,
        width,
        disabled
      }}
    >
      <button
        disabled={disabled}
        style={styles}
        onClick={onClick}
      >{children}</button>
    </ButtonStyled>
  );
};

Button.propTypes = {
  /**
   * Can be set to  [default, primary, link, dashed]
   */
  type: PropTypes.oneOf(['default', 'primary', 'link', 'dashed']),
  /**
   * Set the handler to handle click event
   */
  onClick: PropTypes.func,
  /**
   * Disabled state of button
   */
  disabled: PropTypes.bool,
  /**
   * Extend styled in button
   */
  styles: PropTypes.object,
  /**
   * Height default 58px;
   */
  height: PropTypes.string,
  /**
   * Width default 100%;
   */
  width: PropTypes.string,
  /**
   * Class names that are appended to the defaults
   */
  className: PropTypes.string,

  children: PropTypes.node,
};
